import React, { useState, useRef } from 'react';
import api from '../api';
import useResponsive from '../hooks/useResponsive';

const bosKalem = () => ({ parca_no: '', aciklama: '', foto: null });

export default function AcilParcaSiparis({ kullanici, canGor, canDuzenle, onGeri }) {
  const { isMobile } = useResponsive();
  const [form, setForm]           = useState({ plaka: '', sasi_no: '' });
  const [kalemler, setKalemler]   = useState([bosKalem()]);
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [basarili, setBasarili]   = useState(false);

  const kalemGuncelle = (index, patch) => {
    setKalemler(prev => prev.map((item, i) => i === index ? { ...item, ...patch } : item));
  };

  const fotoSec = (index, e) => {
    const dosya = e.target.files[0];
    if (!dosya) return;
    const url = URL.createObjectURL(dosya);
    kalemGuncelle(index, { foto: { file: dosya, url, name: dosya.name } });
  };

  const gonder = async () => {
    const aktifKalemler = kalemler
      .map((k, i) => ({ ...k, index: i }))
      .filter(k => k.parca_no.trim() || k.aciklama.trim());

    if (!form.plaka.trim() && !form.sasi_no.trim()) return alert('Plaka veya şasi numarası zorunlu');
    if (!aktifKalemler.length) return alert('En az bir parça ekleyin');

    setGonderiliyor(true);
    try {
      const fd = new FormData();
      fd.append('plaka', form.plaka.trim().toUpperCase());
      fd.append('sasi_no', form.sasi_no.trim().toUpperCase());

      const payload = aktifKalemler.map((k, i) => ({
        parca_no: k.parca_no.trim(),
        aciklama: k.aciklama.trim(),
        foto_field: k.foto ? `foto_${i}` : null,
      }));
      fd.append('kalemler', JSON.stringify(payload));

      aktifKalemler.forEach((k, i) => {
        if (k.foto?.file) fd.append(`foto_${i}`, k.foto.file, k.foto.name);
      });

      await api.post('/acil-siparisler', fd);
      setBasarili(true);
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.hata || e.message || 'Sipariş gönderilemedi'));
    }
    setGonderiliyor(false);
  };

  if (basarili) return (
    <div style={{ fontFamily:"'Barlow',sans-serif", background:'var(--bg)', minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ textAlign:'center', padding:40 }}>
        <div style={{ fontSize:56, marginBottom:16 }}>✅</div>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:28, fontWeight:900, marginBottom:8 }}>Sipariş Gönderildi</div>
        <div style={{ fontSize:14, color:'var(--muted)', marginBottom:24 }}>Parça siparişiniz başarıyla iletildi.</div>
        <button onClick={onGeri} style={btnPrimary()}>← Geri Dön</button>
      </div>
    </div>
  );

  return (
    <div style={{ fontFamily:"'Barlow',sans-serif", background:'var(--bg)', minHeight:'100vh' }}>
      {/* Nav */}
      <div style={{ background:'var(--ink)', position:'sticky', top:0, zIndex:200 }}>
        <div style={{ maxWidth:720, margin:'0 auto', padding:isMobile ? '12px 16px' : '0 20px', display:'flex', alignItems:'center', minHeight:isMobile ? 'auto' : 50, gap:12, flexWrap:isMobile ? 'wrap' : 'nowrap' }}>
          <button onClick={onGeri} style={navBtn()}>← Geri</button>
          <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:18, fontWeight:900, color:'white', flex:isMobile ? '1 1 100%' : '0 1 auto', order:isMobile ? -1 : 0 }}>
            ⚡ Acil Parça Siparişi
          </span>
        </div>
      </div>

      <div style={{ maxWidth:720, margin:'0 auto', padding:isMobile ? '20px 16px 32px' : '24px 20px' }}>
        {/* Araç bilgisi */}
        <div style={kartStyle()}>
          <div style={kartBaslik()}>Araç Bilgisi</div>
          <div style={{ display:'grid', gridTemplateColumns:isMobile ? '1fr' : '1fr 1fr', gap:14 }}>
            <div>
              <label style={lbl()}>Plaka</label>
              <input value={form.plaka} onChange={e => setForm(f => ({...f, plaka: e.target.value.toUpperCase()}))}
                placeholder="34 ABC 123" style={inp()} />
            </div>
            <div>
              <label style={lbl()}>Şasi Numarası</label>
              <input value={form.sasi_no} onChange={e => setForm(f => ({...f, sasi_no: e.target.value.toUpperCase()}))}
                placeholder="WDB..." style={inp()} />
            </div>
          </div>
        </div>

        {/* Parçalar */}
        <div style={kartStyle()}>
          <div style={{ display:'flex', alignItems:isMobile ? 'stretch' : 'center', justifyContent:'space-between', marginBottom:16, gap:12, flexDirection:isMobile ? 'column' : 'row' }}>
            <div style={kartBaslik()}>Parçalar</div>
            <button onClick={() => setKalemler(p => [...p, bosKalem()])} style={{ ...btnPrimary(), width:isMobile ? '100%' : 'auto' }}>
              + Parça Ekle
            </button>
          </div>

          {kalemler.map((kalem, index) => (
            <div key={index} style={{ borderTop:'1px solid var(--border)', paddingTop:16, marginTop:8 }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
                <div style={{ fontWeight:800, fontSize:13 }}>Parça {index + 1}</div>
                {kalemler.length > 1 && (
                  <button onClick={() => setKalemler(p => p.filter((_, i) => i !== index))}
                    style={{ background:'none', border:'none', cursor:'pointer', color:'var(--accent)', fontSize:18 }}>✕</button>
                )}
              </div>
              <div style={{ display:'grid', gridTemplateColumns:isMobile ? '1fr' : '1fr 1fr', gap:12, marginBottom:12 }}>
                <div>
                  <label style={lbl()}>Parça Numarası</label>
                  <input value={kalem.parca_no} onChange={e => kalemGuncelle(index, { parca_no: e.target.value })}
                    placeholder="Opsiyonel" style={inp()} />
                </div>
                <div>
                  <label style={lbl()}>Açıklama</label>
                  <input value={kalem.aciklama} onChange={e => kalemGuncelle(index, { aciklama: e.target.value })}
                    placeholder="Parça açıklaması" style={inp()} />
                </div>
              </div>
              <div>
                <label style={lbl()}>Fotoğraf (opsiyonel)</label>
                {kalem.foto ? (
                  <div style={{ position:'relative', display:'inline-block' }}>
                    <img src={kalem.foto.url} alt="" style={{ width:isMobile ? '100%' : 120, maxWidth:220, height:isMobile ? 180 : 120, objectFit:'cover', borderRadius:8 }} />
                    <button onClick={() => kalemGuncelle(index, { foto: null })}
                      style={{ position:'absolute', top:4, right:4, background:'rgba(0,0,0,.6)', border:'none', color:'white', borderRadius:'50%', width:24, height:24, cursor:'pointer', fontSize:12 }}>✕</button>
                  </div>
                ) : (
                  <label style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', gap:8, cursor:'pointer', padding:'10px 16px', borderRadius:6, border:'1px solid rgba(41,128,185,.3)', background:'rgba(41,128,185,.06)', color:'#2980b9', fontSize:13, fontWeight:700, width:isMobile ? '100%' : 'auto' }}>
                    📷 Fotoğraf Ekle
                    <input type="file" accept="image/*" onChange={e => fotoSec(index, e)} style={{ display:'none' }} />
                  </label>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Gönder */}
        <div style={{ display:'flex', gap:12, flexDirection:isMobile ? 'column-reverse' : 'row' }}>
          <button onClick={onGeri} style={{ ...btnSecondary(), width:isMobile ? '100%' : 'auto' }}>İptal</button>
          <button onClick={gonder} disabled={gonderiliyor} style={{ ...btnPrimary(), flex:1, opacity: gonderiliyor ? .6 : 1 }}>
            {gonderiliyor ? 'Gönderiliyor...' : '⚡ Siparişi Gönder'}
          </button>
        </div>
      </div>
    </div>
  );
}

const kartStyle    = () => ({ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:8, padding:20, marginBottom:16 });
const kartBaslik   = () => ({ fontFamily:"'Barlow Condensed',sans-serif", fontSize:16, fontWeight:900, marginBottom:14, textTransform:'uppercase', letterSpacing:.5 });
const navBtn       = () => ({ background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.15)', color:'rgba(255,255,255,.8)', padding:'6px 12px', borderRadius:3, cursor:'pointer', fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, fontWeight:700, letterSpacing:1, textTransform:'uppercase' });
const btnPrimary   = () => ({ background:'var(--accent)', border:'none', color:'white', padding:'10px 20px', borderRadius:4, cursor:'pointer', fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, fontWeight:800, letterSpacing:.5 });
const btnSecondary = () => ({ background:'var(--surface2)', border:'1px solid var(--border2)', color:'var(--ink)', padding:'10px 20px', borderRadius:4, cursor:'pointer', fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, fontWeight:700 });
const lbl          = () => ({ display:'block', fontSize:11, fontWeight:700, letterSpacing:.5, textTransform:'uppercase', color:'var(--muted)', marginBottom:6 });
const inp          = () => ({ width:'100%', padding:'9px 12px', border:'1px solid var(--border2)', borderRadius:4, fontSize:13, fontFamily:"'Barlow',sans-serif", background:'var(--surface)', color:'var(--ink)', boxSizing:'border-box' });
